/* eslint-disable no-nested-ternary */
import React from 'react';

import moment from 'moment';
import { get } from 'lodash';

export default function generateListContent(config, entity, navigate) {
  return config.map((part) => {
    let value = part.title.includes('Date')
      ? moment(entity[part.field]).isValid()
        ? moment(entity[part.field]).format('M/D/YY')
        : 'N/A'
      : get(entity, part.field);

    if (value === true || value === false) {
      value = value.toString();
    }

    if (part.format) {
      value = part.format(value, entity);
    }

    if (!value || !value?.trim?.()) {
      return null;
    }

    return (
      <div key={part.title} className="flex gap-2">
        <div className="font-bold">{part.title}:</div>
        <div
          onClick={part.link ? () => navigate(part.link) : () => {}}
          className={
            part.link ? 'text-indigo-500 hover:underline cursor-pointer' : ''
          }
        >
          {value}
        </div>
      </div>
    );
  });
}
